import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
// import ReactPullToRefresh from 'react-pull-to-refresh'
import BasePage from '../../baseClasses/BasePage';
import UserDashboard from '../../components/UserDashboard';
import dataModel from '../../models/DataModel';
import AnalyticsDAO from '../../dao/AnalyticsDAO';
import mobileBridge from '../../helpers/MobileBridge';
import MobileSpinner from '../../components/MobileSpinner';
import ModalBannerConstants from '../../constants/ModalBannerConstants';
import { PageNames } from '../../constants/ReduxConstants';
import PageStateDAO from '../../dao/PageStateDAO';
import { location_root } from '../../dao/LocationsDAO';
import { RecordStates } from '../../constants/ReduxConstants';
import CollectionDataSource from '../../dao/DataSource/CollectionDataSource';
import DataSource from '../../dao/DataSource/DataSource';
import _ from 'lodash';
import './DashboardWrapper.scss';

const mobile_dashboard_project_root = {
  project: {
    location: {},
    users: {},
    project_manager: {},
  },
};

class DashboardWrapper extends BasePage {
  constructor(props) {
    super(props);
    const locationCounts = dataModel.locationsDAO.getLocationsCountFromStore(localStorage.loggedin_user_id, { recordDescriptor: location_root });
    const taskCounts = dataModel.AnalyticsDAO.getTaskCountsFromStore(localStorage.loggedin_user_id);

    this.state = {
      reloadedCount: 0,
      resetPaging: false,
      fetching: false,   
      taskMetrics: null,
      projects: null,
      locationCounts,
      taskCounts,
    };
  }

  handleProjectsUpdate(projects, action, acData, fetchedData) {
   
    this.setState({ projects });
    if (action != 'prefetch' && this.props.currentUser) {

      AnalyticsDAO.getTaskCounts(this.props.currentUser.id, { force: true }).then(taskCounts => {
        this.setState({ taskCounts });
      });

      AnalyticsDAO.getTaskMetrics().then(taskMetrics => {
        this.setState({ taskMetrics });
      });
  
      if (!acData) {
        dataModel.locationsDAO.getLocationsCount(this.props.currentUser.id, { recordDescriptor: location_root }).then(locationCounts => {
          this.setState({ locationCounts: locationCounts });
        });
      }
    }
  }

  handleSetupDataSource() {
    if (this.props.currentCompany && this.props.currentUser) {
      if (this.projectsDataSource) {
        this.projectsDataSource.release();
      }

      this.projectsDataSource = new CollectionDataSource('UserProjectsCollection', 'Project', mobile_dashboard_project_root, this.handleProjectsUpdate,
        localStorage.loggedin_user_id, { perPage: 4, page: 0 });
      this.projectsDataSource.current();
      this.userDataSource = new DataSource('User', this.props.currentUser, { user: { additionalFields: ['profile_image'], role: {}, companies: {}, company_vendor_users: {} } }, this.handleUserRetrieved);
    }
  }

  componentDidMount() {
    mobileBridge.initialize(this.props.history);

    // register for speech detection
    dataModel.mobileBridge.addSpeechDetectedObserver(this.handleSpeechDetected);

    if (this.props.currentUser && (!this.props.currentUser.settings || !this.props.currentUser.settings.has_viewed_mobile_notifications_announcement)) {
      dataModel.showCircleGlobalModal(ModalBannerConstants.NOTIFICATIONS_ANNOUNCEMENT_CIRCLE_ANNOUNCEMENT, null);
    }
    this.handleSetupDataSource();
  }

  componentWillUnmount() {
    if (this.projectsDataSource) {
      this.projectsDataSource.release();
      this.projectsDataSource = null;
    }
    if (this.userDataSource) {
      this.userDataSource.release();
      this.userDataSource = null;
    }
    dataModel.mobileBridge.removeSpeechDetectedObserver(this.handleSpeechDetected);
  }

  componentDidUpdate(prevProps) {
    const { task_metrics } = this.props;
    if ((this.props.currentUser && (!prevProps.currentUser || prevProps.currentUser.id != this.props.currentUser.id))
      || this.props.online != prevProps.online) {
      if (this.props.online != prevProps.online) {
        this.setState({ resetPaging: !this.state.resetPaging });
      }
      this.handleSetupDataSource();
    }

    if (task_metrics && task_metrics._recordState == RecordStates.NEEDS_SYNC && (!prevProps.task_metrics || task_metrics._recordState != prevProps.task_metrics._recordState)) {
      AnalyticsDAO.getTaskMetrics().then(taskMetrics => {
        this.setState({ taskMetrics });
      });
    }
  }

  handleUserRetrieved(user, action, acData, fetchedData) {
    if (!action) {
      dataModel.usersDAO.currentUser = user;
    }
  }

  handleSpeechDetected(speechText) {
    const { projects } = this.state;
    const speechDataLowerWithoutSpaces = speechText.replace(/ /g,'').toLowerCase();
    if (projects && projects.projects) {
      for (let project of projects.projects) {
        const projectNameLowerWithoutSpaces = project.name.replace(/ /g,'').toLowerCase();
        if (projectNameLowerWithoutSpaces == speechDataLowerWithoutSpaces) {
          PageStateDAO.setPageStateEntry(PageNames.MOBILE_PROJECT_DETAIL, 'tabSelected', 'Tasks');
          this.props.history.push({
            pathname: '/mobile/projects/' + project.id,
            state: { 
              projectName: project.name, 
              projectStatus: project.status,
            },
          });
          return;
        }
      }
      setTimeout(() => {
        dataModel.showGlobalModal('HANDSFREE_ERROR_MODAL', {
          message: 'Hint: try saying the name of a project',
        });
      }, 2000);
    }
  }

  handleNextPage() {
    return this.projectsDataSource.next();
  }

  handleProjectSearch(searchString) {
    // TODO: use fetchCurrent here
    if (searchString != this.projectsDataSource.searchString) {
      this.projectsDataSource.searchString = searchString;
      return this.projectsDataSource.current();
    }
    else {
      return Promise.resolve(this.state.projects);
    }
  }

  handleRefresh(resolve, reject) {
    resolve();
    window.location.reload();
  }

  handleCompanySelect(companyId) {
    dataModel.companiesDAO.getCurrentCompany(companyId, null, (prefetchedCompany) => {
      if (prefetchedCompany) {
        
      }
    }).then(company => {
      if (company) {
        dataModel.hideGlobalBanner();
        // set company on data model
        this.handleSetupDataSource();
        dataModel.mobileBridge.fireNativeEvent('hybrid.set_company', {
          data: { company_id: company.id },
        });
      }
    });
  }

  handleProjectFavorites(favorited, isFavorite) {
    let projects = this.state.projects;

    let project = projects.projects.filter(project => { return project.id == favorited.id; });
    if (project.length > 0) {
      project[0].is_favorite = isFavorite;
      projects.projects = this.sortProjects(projects.projects);

      this.setState({ projects, resetPaging: !this.state.resetPaging });
    }
  }

  sortProjects(projects) {
    let favorites = [];
    let notFavorites = projects.filter(project => {
      if (!project.is_favorite) {
        return project;
      } else {
        favorites.push(project);
      }
      return false;
    });
    const clonedProjects = [...favorites.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1), ...notFavorites.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1)];
    return clonedProjects;
  }

  render() {
    if (this.state.navPath) {
      this.props.history.push({ pathname: this.state.navPath });
    }

    if (!this.state.projects) {
      return null;
    }

    if (this.state.fetching) {
      return (<div className="dashboard-wrapper mobile-wrapper">
        <div className="dashboard content-wrapper">
          <MobileSpinner/>
        </div>
      </div>);
    }

    return (
      // <ReactPullToRefresh onRefresh={this.handleRefresh}>
      <div className="dashboard-wrapper mobile-wrapper">
        <div className="dashboard content-wrapper">
          <UserDashboard
            dontAnimate={true}
            user={this.props.currentUser}
            projects={this.state.projects}
            taskCounts={this.state.taskCounts}
            taskMetrics={this.state.taskMetrics}
            locationCounts={this.state.locationCounts}
            handleUpdateNotification={this.handleUpdateNotification}
            getNextPage={this.handleNextPage}
            handleProjectSearch={this.handleProjectSearch}
            resetPaging={this.state.resetPaging}
            allowCompanySelect={true}
            handleCompanySelect={this.handleCompanySelect}
            companies={ this.props.currentUser && this.props.currentUser.companies }
            currentUser={ this.props.currentUser }
            currentCompany={ this.props.currentCompany }
            affiliateCompanies={ this.props.currentUser && this.props.currentUser.vendor_companies }
            isSuperUser={ this.props.permissions && this.props.permissions.isSuperUser }
            handleProjectFavorites={this.handleProjectFavorites}
          />
        </div>
      </div>
      // </ReactPullToRefresh>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    task_metrics: state.analytics.task_metrics,
    actionCableUpdate: state.main.actionCableUpdate,
    notificationsDataModel: dataModel.notificationsDataModel,
    notifications: state.notifications.notifications,
    navigateUri: state.main.navigateUri,
    systemPopup: state.main.systemPopup,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
    permissions: state.new_users.permissions,
    needsLogin: state.main ? state.main.needsLogin : null,
    online: state.main.online,
  };
};

export default withRouter(connect(mapStateToProps)(DashboardWrapper));



// WEBPACK FOOTER //
// ./src/mobileWrappers/DashBoardWrapper/index.js